import React from 'react';
import Button from '../../../components/ui/Button';
import { useWeb3 } from '../../../contexts/Web3Context';

const QuickActionButtons = ({ onActionClick }) => {
  const { isConnected, connectWallet } = useWeb3();

  const actions = [
    { label: 'Send', icon: 'Send', color: 'primary', onClick: () => onActionClick?.('send') },
    { label: 'Receive', icon: 'Download', color: 'outline', onClick: () => onActionClick?.('receive') },
    { label: 'Swap', icon: 'RefreshCw', color: 'outline', onClick: () => onActionClick?.('swap') },
    { 
      label: isConnected ? 'Buy' : 'Connect Wallet', 
      icon: isConnected ? 'Plus' : 'Wallet', 
      color: isConnected ? 'outline' : 'default', 
      onClick: isConnected ? () => onActionClick?.('buy') : connectWallet 
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
      {actions?.map((action, index) => (
        <Button
          key={index}
          variant={action?.color}
          size="lg"
          iconName={action?.icon}
          iconPosition="left"
          onClick={action?.onClick}
          fullWidth
        >
          {action?.label}
        </Button>
      ))}
    </div>
  );
};

export default QuickActionButtons;